<script>

    import { toast } from 'bulma-toast'

    import { orderLinkStore, modalStore } from '../stores'
    import OrdersLinksService from '../$services/orders.links.service'

    import LocationsComponent from '../locations/component.pickup.link.svelte'
    import PackagesComponent from '../packages/component.package.link.svelte'

    import Spinner from '../$components/spinner.svelte'

    const { HOST_APP } = _CONSTANTS_

    let referenceInput;
    let loading = false
    let newLink = true
    let data = {
        payment: 'user'
    }

    async function createOrderLink() {

        if(data.quotation === 'user') {
            delete data.package 
            delete data.pickup
        }

        loading = true
        const resp = await OrdersLinksService.createOrderLink(data)
        loading = false
        newLink = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
        
        orderLinkStore.set(resp.data)
    }

    function onCopy() {

        referenceInput.select()
        referenceInput.setSelectionRange(0, 99999)
        document.execCommand("copy")
        toast({message: 'Link copiado', type: 'is-success'})
        modalStore.close()
        newLink = true
    }

</script>

<Spinner {loading} />

{#if !loading && newLink}
    <form on:submit={createOrderLink}>
        
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">¿Quién seleccionará la paquetería?</label>
                    <div class="control">
                        <div class="select">
                            <select bind:value={data.quotation} required>
                                <option value="">Selecciona una opción</option>
                                <option value="user">Yo</option>
                                <option value="client">Mi cliente</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {#if data.quotation === 'client'}
            <div class="title"><b>Dirección de origen</b></div>
            <div class="is-divider"></div>

            <LocationsComponent bind:location={data.pickup} />
            
            <div class="title"><b>Paquete</b></div>
            <div class="is-divider"></div>
            
            <PackagesComponent bind:ipackage={data.package} />
        {/if}
        <div class="items-end">
            <button type="submit" class="button is-primary">
                <span class="icon"><i class="fas fa-link"></i></span>
                <span>Generar link</span>
            </button>
        </div>
    </form>
{/if}

{#if !newLink}
    <div class="columns">
        <div class="column">
            <div class="items-space-around">
                <input bind:this={ referenceInput } value={`${HOST_APP}/#/orderslinks/${ $orderLinkStore._id }`} class="input space-right" readonly>
                <button on:click={onCopy} class="button" data-tooltip="Copiar link">
                    <span class="icon"><i class="fas fa-copy"></i></span>
                </button>
            </div>
            <small>Puedes compartir el link de la órden</small>
        </div>
    </div>
{/if}